
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that scrolls the window to the top when the route changes,
 * but preserves scroll position when only the language prefix changes
 */
const ScrollToTop = () => {
  const location = useLocation();
  const prevPathRef = useRef<string>('');

  useEffect(() => {
    const currentPath = location.pathname;
    const prevPath = prevPathRef.current;

    // Extract paths without language prefix for comparison
    const currentPathWithoutLang = currentPath.replace(/^\/[a-z]{2}(\/|$)/, '/');
    const prevPathWithoutLang = prevPath.replace(/^\/[a-z]{2}(\/|$)/, '/');

    // Only scroll to top if the actual page changed, not just the language
    if (currentPathWithoutLang !== prevPathWithoutLang) {
      window.scrollTo(0, 0);
    }

    // Update the previous path for next comparison
    prevPathRef.current = currentPath;
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;
